import { DialogFooter, DialogHeader, DialogTitle, DialogDescription } from '../../../../common/components/ui/dialog';
import { Button } from '../../../../common/components/ui/button';
import { useCart } from '../../state-hooks/useCart';
import { cancelCart } from '../../actions/cartActions';
import { useTranslation } from 'react-i18next';
import ProgressButton from '../../../../common/components/ProgressButton';

interface CartDialogConfirmCancelProps {
  onBack: () => void;
}

export function CartDialogConfirmCancel({ onBack }: Readonly<CartDialogConfirmCancelProps>) {
  const { t } = useTranslation();
  const { isCancellingCart } = useCart();

  return (
    <>
      <DialogHeader>
        <DialogTitle className={'flex items-center'}>{t('Warenkorb verwerfen')}?</DialogTitle>
        <DialogDescription>
          {t('Sind Sie sicher, dass Sie alle Artikel aus dem Warenkorb entfernen möchten?')}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className={'flex-col desktop:flex-row gap-4 desktop:gap-1'}>
        <Button
          variant={'primaryOutline'}
          onClick={onBack}
          disabled={isCancellingCart}
          data-testid={'cart-cancel-confirm-back'}
        >
          {t('Abbrechen')}
        </Button>
        <ProgressButton inProgress={isCancellingCart} onClick={cancelCart} data-testid={'cart-cancel-confirm-ok'}>
          {t('Löschen')}
        </ProgressButton>
      </DialogFooter>
    </>
  );
}
